import Vue from 'vue';
import store from '../../store';
import batchTransformer from '../../transformers/batch';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const batches = batchTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllBatches', batches);
  resolve(batches);
};

const failed = () => {};


export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/production/batch', params))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batch/all.js